import React from "react";
import { Link } from "react-router-dom";
import contanuityLogo from "../assest/images/contanuity-lite.png";

const NotFound = (): JSX.Element => (
  <div id="notfound">
    <div className="notfound">
      <img src={contanuityLogo} alt="" width="50%" className="mb-5" />
      <div className="notfound-404">
        <h1>404</h1>
        <h2>Page not found</h2>
      </div>
      <Link to="/"> back to Homepage</Link>
    </div>
  </div>
);

export default NotFound;
